import { render, staticRenderFns } from "./ms-prescription.vue?vue&type=template&id=422ada1a&scoped=true"
import script from "./ms-prescription.vue?vue&type=script&lang=js"
export * from "./ms-prescription.vue?vue&type=script&lang=js"
import style0 from "./ms-prescription.vue?vue&type=style&index=0&id=422ada1a&prod&lang=scss&scoped=true"
import style1 from "./ms-prescription.vue?vue&type=style&index=1&id=422ada1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422ada1a",
  null
  
)

export default component.exports